import { requiredFieldValidator } from './requiredFieldVaildator';

export function phoneNumberDisplayFormat(phoneNumberString: string) {
  const cleaned = phoneNumberString.replace(/\D/g, '');
  const res = `${cleaned.slice(0, 3)}${cleaned.length > 3 ? '-' : ''}${cleaned.slice(3, 6)}${
    cleaned.length > 6 ? '-' : ''
  }${cleaned.slice(6)}`;
  return res;
}

export function phoneNumberParser(phoneNumber: string) {
  return phoneNumber.split('-').join('');
}

interface InputValidator {
  (name: string): string;
}
export const phoneNumberValidator: InputValidator = (phoneNumber) => {
  let errMsgStr = '';
  const cleanedPhoneNumber = phoneNumberParser(phoneNumber);
  if (!requiredFieldValidator(cleanedPhoneNumber.trim())) errMsgStr = `* phone number is required`;
  else if (!/^[0-9]+(-[0-9]+)*$/.test(cleanedPhoneNumber.trim()))
    errMsgStr = '* phone number should only contain numbers';
  else if (cleanedPhoneNumber.length > 12) errMsgStr = `* phone number must be less than 12 digits`;
  else if (cleanedPhoneNumber.length < 10) errMsgStr = `* phone number must be 10 digits`;
  return errMsgStr;
};
